'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';

/** Separate from parser-cache and docparser session keys. */
export const UPLOAD_SKIP_PARSE_SETTINGS_KEY = 'deal-upload-skip-parse';
export type UploadSkipParseSettings = {
  skipParse: boolean;
};
const DEFAULT_SETTINGS: UploadSkipParseSettings = {
  skipParse: false
};
function parseStoredSettings(raw: string | null): UploadSkipParseSettings {
  if (!raw) {
    return DEFAULT_SETTINGS;
  }
  try {
    const parsed = JSON.parse(raw) as Partial<UploadSkipParseSettings>;
    return {
      skipParse: parsed.skipParse === true
    };
  } catch {
    return DEFAULT_SETTINGS;
  }
}
export function readUploadSkipParseSettings(): UploadSkipParseSettings {
  if (typeof window === 'undefined') {
    return DEFAULT_SETTINGS;
  }
  return parseStoredSettings(sessionStorage.getItem(UPLOAD_SKIP_PARSE_SETTINGS_KEY));
}
function writeUploadSkipParseSettings(settings: UploadSkipParseSettings): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(UPLOAD_SKIP_PARSE_SETTINGS_KEY, JSON.stringify(settings));
}
export function useUploadSkipParseSettings() {
  const $ = _c(5);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setSettings(readUploadSkipParseSettings());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => {
      setSettings(current => {
        const next = {
          ...current,
          skipParse: value
        };
        writeUploadSkipParseSettings(next);
        return next;
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setSkipParse = t2;
  let t3;
  if ($[3] !== settings) {
    t3 = {
      settings,
      setSkipParse
    };
    $[3] = settings;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}